import { Emitter, Event } from "../../../../../features/event-emitter"
import { Data, ModalId, useUIActions } from "../../../../../features/ui"
import { PriceOutlineType } from "../../../../operations"
import { usePurchaseService } from "../../../../purchases"
import { useTicketLoaders } from "../../../loaders/ticketLoaders"

export const useActions = () => {
    const ticketLoaders = useTicketLoaders()
    
    const { createPurchaseTicket, updatePurchaseTicket } = usePurchaseService()
    const { openModal, closeModal } = useUIActions()

    const submitTicketOrOpenModal = async (
        ticketData: Data,
        priceOutline: PriceOutlineType,
        purchaseId: string,
        subtotal: number,
        vatAmount: number,
        taxItemsData: Data[],
        createMode: boolean,
        ticketFile?: File,
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const { loadParentTickets } =  ticketLoaders()
        const tickets = await loadParentTickets(purchaseId)
        const ticketsAmount = tickets
            .filter(ticket => ticket.id !== ticketData.id)
            .reduce((sum, ticket) => sum + ticket.subtotal + ticket.vatAmount, 0)
        const diff = Math.abs(priceOutline.total - ticketsAmount - (subtotal + vatAmount))
        if (diff > 1) {
            closeModal(ModalId.SPINNER)
            setTimeout(() => openModal(ModalId.TICKET_AMOUNT_DIFFERS), 500)
        } else {
            submitTicket(
                ticketData,
                purchaseId,
                taxItemsData,
                createMode,
                ticketFile
            )
        }
    }

    const submitTicket = async (
        ticketData: Data,
        purchaseId: string,
        taxItemsData: Data[],
        createMode: boolean,
        ticketFile?: File,
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const data = {
            ...ticketData,
            ticketFile
        }
        if (createMode) {
            await createPurchaseTicket(purchaseId, data, taxItemsData)
        } else {
            await updatePurchaseTicket(purchaseId, data, taxItemsData)
        }

        Emitter.emit(Event.DB_SUBMIT_DONE, createMode)
    }
    
    return {
        submitTicketOrOpenModal,
        submitTicket
    }
}
